/**
 * L6 tabs-r1 — /more 와 PC 「전체 메뉴」 패널이 함께 쓰는 두 조각(순수 · 훅 없음 · 서버/클라이언트 어디서나).
 *   · MoreQuickTiles — 바로가기 타일 8(2×4 · 아이콘 22 + 라벨 12). 항목은 nav-config moreQuickLinks()(MORE_GROUPS 의 id 참조 · 중복 정의 0).
 *   · MoreAdCard — 광고 1줄 카드 「분양 광고 문의 — 현장·시군구 배너 · 30일 사람 조회 N회」 + 「견적 받기」 44px. N 은 서버가 넘긴 실값(없으면 문구 생략).
 *   색 추가 0(네이비·기존 토큰) · 링크는 전부 정적 <a href>(서버 HTML).
 */
import React, { type ReactNode } from 'react'; // vitest(클래식 JSX) 렌더 검증용
import { MORE_AD_FROM, moreQuickLinks, type NavLink } from '@/lib/nav/nav-config';
import { navEvAttrs, type NavEventType } from '@/lib/nav/nav-track';

const P = (d: string) => <path d={d} />;
/** 바로가기 아이콘(선 1.7 · 22px) — id 별. 없는 id 는 점 셋. */
export const QUICK_ICONS: Record<string, ReactNode> = {
  join_board: P('M4 5.5h16v10H9l-4.5 3.5V15.5H4z'),
  apt_unsold: <><rect x="5" y="3.5" width="14" height="17" rx="1.5" />{P('M9 8h6M9 12h6M9 16h3')}</>,
  tool_calc: <><rect x="5" y="3" width="14" height="18" rx="2" />{P('M8.5 7h7M8.5 11.5h2M13.5 11.5h2M8.5 15.5h2M13.5 15.5h2')}</>,
  tool_complex: P('M3.5 20.5h17M6 20.5V9l4-2.5V20.5M10 20.5V6.5L18 10v10.5M13.5 13h2M13.5 16.5h2'),
  stock_home: P('M4 17l5-6 4 3 7-8M15 6h5v5'),
  apt_region: P('M12 21s-6-5.3-6-10a6 6 0 1 1 12 0c0 4.7-6 10-6 10zM12 13.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z'),
  set_notify: P('M6 17V11a6 6 0 1 1 12 0v6l1.5 1.5H4.5zM10 20.5a2 2 0 0 0 4 0'),
  set_region: P('M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM19.4 13.5a7.7 7.7 0 0 0 0-3l2-1.5-2-3.5-2.4 1a7.7 7.7 0 0 0-2.6-1.5L14 2.5h-4l-.4 2.5A7.7 7.7 0 0 0 7 6.5l-2.4-1-2 3.5 2 1.5a7.7 7.7 0 0 0 0 3l-2 1.5 2 3.5 2.4-1a7.7 7.7 0 0 0 2.6 1.5l.4 2.5h4l.4-2.5a7.7 7.7 0 0 0 2.6-1.5l2.4 1 2-3.5z'),
};
const DOTS = <><circle cx="6" cy="12" r="1.3" /><circle cx="12" cy="12" r="1.3" /><circle cx="18" cy="12" r="1.3" /></>;

export function MoreQuickTiles({ ev = 'more_click', className = 'kd-more-quick', items = moreQuickLinks() }: { ev?: NavEventType; className?: string; items?: readonly NavLink[] }) {
  if (!items.length) return null;
  return (
    <ul className={className} aria-label="바로가기" data-more-quick="">
      {items.map((it) => (
        <li key={it.id}>
          <a href={it.href} className={`${className}__a`} rel={it.nofollow ? 'nofollow' : undefined} data-kd-region-link={it.regionLink} {...navEvAttrs(ev, it.id)}>
            <svg className={`${className}__ico`} viewBox="0 0 24 24" aria-hidden="true" focusable="false">{QUICK_ICONS[it.id] ?? DOTS}</svg>
            <span className={`${className}__l`}>{it.label}</span>
          </a>
        </li>
      ))}
    </ul>
  );
}

/** 광고 카드 — 숫자 N 은 실값일 때만 문구에 넣는다(지어낸 값 0). */
export function MoreAdCard({ visitors30d, className = 'kd-more-adcard' }: { visitors30d: number | null; className?: string }) {
  const n = typeof visitors30d === 'number' && visitors30d > 0 ? visitors30d.toLocaleString('ko-KR') : null;
  return (
    <div className={className} data-more-group="ad" data-more-adcard="">
      <div className={`${className}__t`}>
        <b>분양 광고 문의</b>
        <span className={`${className}__s`}>현장·시군구 배너{n ? <> · 30일 사람 조회 <em className="num">{n}</em>회</> : null}</span>
      </div>
      <a href={`/advertise?from=${MORE_AD_FROM}#quote`} className={`${className}__btn`} data-nav-group="ad" {...navEvAttrs('more_click', 'ad_quote')}>견적 받기</a>
    </div>
  );
}
